export default __webpack_public_path__ + "static/media/ProblemBrief.89e0095b.pdf";